module.exports = __webpack_public_path__ + "images/favicon-32.3e74fb071e8db326e030a9779c71cb3d.png";